<mat-spinner diameter="80" color="#00264B"></mat-spinner>
